/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { ReactElement, useEffect } from 'react';

import {
  ButtonPattern,
  Grid,
  GridItem,
  Paragraph,
  Container,
} from '@constellation/core';
import { useContent } from '@interstellar/react-app-content';
import { useNavigate } from '@interstellar/react-app-routing';
import PageHeading from 'components/pageHeading/PageHeading';
import StyledBox from 'components/style/styledBox/StyledBox';
import { Button, Link } from 'components/tagging';

import { StyledImage } from './FullSignatoryPage.styled';
import { FullSignatoryPageContent } from './FullSignatoryPageContent';
import NeedHelp from './needHelp/NeedHelp';
import {
  BUTTON_EVENTS,
  JOURNEY_STEPS,
} from '../../constants/analytics.constants';
import * as Analytics from '../../utils/analytics';

// Component to display the 'Are you a full signatory page?'
export default function FullSignatoryPage(): ReactElement {
  const { fullSignatoryPageContent } = useContent<FullSignatoryPageContent>();
  const navigate = useNavigate();

  const handleNavigation = (path: string): void => {
    navigate(path);
  };
  useEffect(() => {
    Analytics.setPageLoadEvent(
      JOURNEY_STEPS.ONLINE_REGISTRATION.FULL_SIGNATORY_VERIFICATION,
    );
  }, []);

  return (
    <Container padding="none">
      {fullSignatoryPageContent &&
        fullSignatoryPageContent.map(
          ({
            serviceName,
            header,
            content,
            imageSrc,
            imageAltText,
            yesBtn,
            yesBtnHref,
            noBtn,
            noBtnHref,
            previousLink,
            previousHref,
          }) => (
            <React.Fragment key="content">
              {/* ServiceName and Heading content */}
              <PageHeading serviceName={serviceName} header={header} />
              <Grid alignX="center" alignY="top">
                {/* Description, Image and buttons  */}
                <GridItem lg={8}>
                  <StyledBox>
                    <Grid alignX="center" alignY="center">
                      <GridItem>
                        <Paragraph>{content}</Paragraph>
                      </GridItem>
                      <GridItem sm={12} md={6} lg={6}>
                        <StyledImage alt={imageAltText} src={imageSrc} />
                      </GridItem>
                      <GridItem>
                        {/* Buttons Layout */}
                        <ButtonPattern>
                          <Button
                            variation="secondary"
                            onClick={() => handleNavigation(yesBtnHref)}
                            taggingLabel={yesBtn}
                          >
                            {yesBtn}
                          </Button>
                          <Button
                            variation="secondary"
                            onClick={() => handleNavigation(noBtnHref)}
                            taggingLabel={noBtn}
                          >
                            {noBtn}
                          </Button>
                          <Link
                            iconPosition="left"
                            onClick={() => handleNavigation(previousHref)}
                            event={BUTTON_EVENTS.PREVIOUS}
                          >
                            {previousLink}
                          </Link>
                        </ButtonPattern>
                      </GridItem>
                    </Grid>
                  </StyledBox>
                </GridItem>

                <GridItem lg={4}>
                  {/* FAQs accordian */}
                  <NeedHelp />
                </GridItem>
              </Grid>
            </React.Fragment>
          ),
        )}
    </Container>
  );
}
